/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Sponsor_TitleInputs */



/**
* | output |
* | --- |
* | "Sponsor New Member" |
*
* @param {Vekn_Sponsor_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sponsor_title = /** @type {((inputs?: Vekn_Sponsor_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sponsor_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parrainer un nouveau membre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Patrocinar nuevo miembro")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Patrocinar Novo Membro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sponsorizza Nuovo Membro")
	return /** @type {LocalizedString} */ ("Sponsor New Member")
});